import React from 'react';
import { AvatarSizeTokens, BorderRadiusTokens, ButtonTypeTokens, ColorTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackFlexWrap, StackJustifyContent, StackType, TypographyTypeTokens, } from '@voltmoney/schema';
import { View } from 'react-native';
import Card from '../card/Card';
import Stack from '../stack/Stack';
import Typography from '../typography/Typography';
import Avatar from '../avatar/Avatar';
import Space from '../space/Space';
import _map from 'lodash-es/map';
import Tag from '../tag/Tag';
import Button from '../button/Button';
import Icon from '../icon/Icon';
const MemberCard = ({ avatar, title, subtitle, location, margin = {
    bottom: SizeTypeTokens.XL,
}, headline, chips, chipsTitle, onPress, cta, padding, bgColor = ColorTokens.Grey_600, borderRadius = BorderRadiusTokens.BR2, action, ctaAction, triggerAction, }) => {
    if (!title)
        return React.createElement(React.Fragment, null);
    const interestToString = (interest) => {
        if (interest && interest !== null) {
            let temp = interest.replace(/_/g, ' ');
            return (temp.charAt(0).toUpperCase() + temp.slice(1));
        }
        else {
            return ' ';
        }
    };
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(Card, { bgColor: bgColor, borderRadius: borderRadius, onPress: handleAction, padding: padding, margin: margin, header: {
            children: (React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.spaceBetween },
                React.createElement(View, { style: {
                        flex: 1,
                    } },
                    React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center },
                        React.createElement(Avatar, { uri: avatar, size: AvatarSizeTokens.XL }),
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        React.createElement(View, { style: {
                                flex: 1,
                            } },
                            React.createElement(Typography, { label: title, type: TypographyTypeTokens.H4, numberOfLines: 1 }),
                            React.createElement(Space, { size: SizeTypeTokens.SM }),
                            React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center },
                                location ? (React.createElement(Icon, { name: IconTokens.LocationPin, size: IconSizeTokens.XS, color: ColorTokens.Grey_200 })) : (React.createElement(React.Fragment, null)),
                                React.createElement(Space, { size: location
                                        ? SizeTypeTokens.SM
                                        : SizeTypeTokens.NONE }),
                                React.createElement(Typography, { label: location ? location : subtitle, type: TypographyTypeTokens.B6, color: ColorTokens.Grey_200, numberOfLines: 1 }))))),
                React.createElement(Button, { type: ButtonTypeTokens.IconFilled, labelColor: ColorTokens.Grey_500, onPress: () => {
                        if (cta) {
                            cta();
                        }
                        if (ctaAction) {
                            triggerAction(ctaAction);
                        }
                    }, icon: {
                        name: IconTokens.Chat,
                        size: IconSizeTokens.XL,
                        color: ColorTokens.Grey_500,
                    } }))),
        }, body: {
            children: headline ? (React.createElement(Stack, null,
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Typography, { label: headline, type: TypographyTypeTokens.B6 }))) : (React.createElement(React.Fragment, null)),
        }, footer: {
            children: (React.createElement(Stack, null,
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Typography, { label: chipsTitle, type: TypographyTypeTokens.H7 }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(Stack, { type: StackType.row, flexWrap: StackFlexWrap.wrap }, _map(chips, (item, index) => (React.createElement(Tag, { key: index, label: interestToString(item), margin: {
                        right: SizeTypeTokens.SM,
                        bottom: SizeTypeTokens.SM,
                    } })))))),
        } }));
};
export default React.memo(MemberCard);
export { MemberCard };
